import React, { useState, useEffect } from 'react';
import { SquareChartGantt, SquareClaimIcon, Mail } from 'lucide-react';
import { brandColors } from '../../utils/data';
import { addCommas, formatPercent } from '../../utils/tools';
import classNames from 'classnames';

import { useData } from '../../hooks/useData';
const ClaimEnvelope = ({ envelope, onClick, claimIndex }) => {

  const [repriced, setRepriced] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalSavings, setTotalSavings] = useState(0);

  const [serviceLines, setServiceLines] = useState([]);

  const [repricedTotalClaims, setRepricedTotalClaims] = useState(0);
  const { claimOpenId, claimLines, claimDiagnoses } = useData();

  useEffect(() => {
    
    let ta = envelope.claimInfo.totalAmount;

    setTotalAmount(ta);


    if(envelope.pricing?.repricedAmount){
      setRepriced(true);
      setRepricedTotalClaims(envelope.pricing.repricedAmount);
      setTotalSavings(envelope.pricing.savingsAmount);
    }else{
      setRepriced(false);
      setRepricedTotalClaims(0);
      setTotalSavings(0);
    }

  }, [envelope]);

  const handleClick = () => {
        onClick(envelope.claimInfo.claimId);
  }

  return (
    <div onClick={handleClick} className={classNames("file-envelope", claimOpenId === envelope.claimInfo.claimId ? 'active' : '')}>
      <div className="envelope-header">
        <p className="envelope-title"><SquareChartGantt size={14} color={brandColors.blue} />&nbsp;Claim ID &nbsp;<b>{envelope.claimInfo?.claimId || 'N/A'}</b></p>
        
      </div>
      
      <div style={{marginTop:4,paddingTop:4}} className="envelope-body">
        {envelope.claimInfo && (
          <div className="data-item-group row">

            <div className="data-item-group">
             
              <div className="data-item">
                <div className="data-label">
                  Submitter
                </div>
                <div className="data-value small">
                {envelope.loops.header.submitter.name || 'N/A'}
                </div>
              </div>

              <div className="data-item">
                <div className="data-label">
                  Receiver
                </div>
                <div className="data-value">
                  {envelope.loops.header.receiver.name || 'N/A'}
                </div>
              </div>

              <div className="data-item">
                <div className="data-label">
                  Provider
                </div>
                <div className="data-value">
                  {envelope.loops.billingProvider.provider.name || 'N/A'}
                </div>
              </div>

              { envelope.loops.subscriber?.renderingProvider?.firstName ? (
                <div className="data-item">
                  <div className="data-label">
                    Rendering Provider
                  </div>
                
                  <div className="data-value">
                    {envelope.loops.subscriber.renderingProvider.firstName} {envelope.loops.subscriber.renderingProvider.name}
                  </div>
                
                </div>
              ):null}

              <div className="data-item">
                <div className="data-label">
                  Payer
                </div>
                <div style={{maxWidth:222}} className="data-value">
                {envelope.loops.subscriber.payer.name}
                </div>
              </div>

              <div className="data-item">
                <div className="data-label">
                  Subscriber {envelope.loops.patient?.firstName ? '' : <><span className="mute">|</span> Patient</>}
                </div>
                <div className="data-value">
                  {envelope.loops.subscriber.namePrefix} {envelope.loops.subscriber.firstName} {envelope.loops.subscriber.middleName} {envelope.loops.subscriber.name} {envelope.loops.subscriber.nameSuffix}
                </div>
              </div>

              

              { envelope.loops.patient?.firstName ? (

                <div className="data-item">
                  <div className="data-label">
                    Patient
                  </div>
                  
                    <div className="data-value">
                    {envelope.loops.patient.namePrefix} {envelope.loops.patient.firstName} {envelope.loops.patient.middleName} {envelope.loops.patient.name} {envelope.loops.patient.nameSuffix} 
                    </div>
                 
                </div>
              ):null}

            </div>


            <div className="data-item-group half">
              <div style={{}} className="data-item">
                <div className="data-label">
                  Dxs
                </div>
                <div className="data-value">
                  {envelope.diagnoses.length || 'N/A'}
                </div>
              </div>

              {claimDiagnoses[claimIndex] !== undefined ? (
                <div style={{flexWrap: 'wrap',justifyContent: 'flex-start', gap: 7, padding: '7px 4px'}} className="data-item">
                  { claimDiagnoses[claimIndex].map((line, index) => (
                    <div 
                      key={index} 
                      style={{backgroundColor: line.color ? line.color : '#000'}} 
                      className="active-dot large interactive"
                      data-tooltip-id="navbar-tooltip"
                      data-tooltip-content={line.code.length && !line.code.includes("INVALID") ? `${line.qualifier ? `${line.qualifier} : ` : ''}${line.code}${line.section?.length ? ` : ${line.section}` : ''}` : 'No code'}
                      data-tooltip-place="top"
                    >
                    
                    </div>
                  ))} 
                </div>

              ):null}

              <div className="data-item">
                <div className="data-label">
                  Service Lines
                </div>
                <div className="data-value">
                  {envelope.serviceLines.length || 'N/A'}
                </div>
              </div>
              
              {claimLines[claimIndex] !== undefined ? (
                <div style={{flexWrap: 'wrap',justifyContent: 'flex-start', gap: 7, padding: '7px 4px'}} className="data-item">
                  { claimLines[claimIndex].map((line, index) => (
                    <div 
                      key={index} 
                      style={{backgroundColor: line.codeMeta.sectionColor ? line.codeMeta.sectionColor : line.revenueCodeMeta.sectionColor}} 
                      className="active-dot large interactive"
                      data-tooltip-id="navbar-tooltip"
                      data-tooltip-content={line.code.length && !line.code.includes("INVALID") ? `${line.code}${line.section?.length ? ` : ${line.section}` : ''}` : line.revenueCode !== undefined ? `REV ${line.revenueCode}${line.revenueCodeMeta.section?.length ? ` : ${line.revenueCodeMeta.section}` : ''}` : 'Invalid code'}
                      data-tooltip-place="top"
                    >
                    
                    </div>
                  ))} 
                </div>

              ):null}


              
              

              <div className="data-item">
                <div className="data-label">
                  Total Amount
                </div>
                <div className="data-value">
                  <span style={{color: 'var(--text-secondary)',marginRight: '0.22rem'}} className="mute">$</span>{addCommas(envelope.claimInfo.totalAmount.toFixed(2))}
                
                </div>
              </div>

              { repriced && totalSavings > 0 ? (
                <>
                  <div style={{marginTop: '0.5rem'}} className="data-item">
                    <div style={{position: 'absolute', top: 5, left: -11}} className="active-dot green"></div>
                    <div className="data-label">Savings</div>
                    <div className="data-value">{formatPercent((totalSavings / totalAmount * 100).toFixed(2),false)}<span style={{color: 'var(--text-secondary)',marginLeft: '0.55rem',marginRight: '0.22rem'}} className="mute">$</span>{addCommas(totalSavings.toFixed(2))}</div>
                  </div>
                  <div className="data-item">
                    <div className="data-label">Repriced Amount <span className="mute">(RBP)</span></div>
                    <div className="data-value"><span style={{color: 'var(--text-secondary)',marginRight: '0.22rem'}} className="mute">$</span>{addCommas(repricedTotalClaims.toFixed(2))}</div>
                  </div>
                </>
              ):null}
              
            </div>



           
           

          
            
          </div>
        )}
        
        {envelope.documents && envelope.documents.length > 0 && (
          <div className="envelope-documents">
            <h5 className="documents-title">Documents</h5>
            <div className="documents-list">
              {envelope.documents.map((doc, index) => (
                <div key={index} className="document-item">
                  <span className="document-name">{doc.name || `Document ${index + 1}`}</span>
                  <span className="document-type">{doc.type || 'PDF'}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      
     
    </div>
  );
};

export default ClaimEnvelope;
